import { render, staticRenderFns } from "./formSetDeptPost.vue?vue&type=template&id=4f9b4efc&"
import script from "./formSetDeptPost.vue?vue&type=script&lang=js&"
export * from "./formSetDeptPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports